/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Research_Review_TitleInputs */

const en_research_review_title = /** @type {(inputs: Research_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review`)
};

/**
* | output |
* | --- |
* | "Review" |
*
* @param {Research_Review_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const research_review_title = /** @type {((inputs?: Research_Review_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Research_Review_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_research_review_title(inputs)
});